import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-amount-declined',
  templateUrl: './amount-declined.component.html',
  styleUrls: ['./amount-declined.component.css']
})
export class AmountDeclinedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/amount-declined/amount-declined.component.ts